const stringResources = {
  'bad-format': 'Bad format'
}

export default (resourceId) =>
  stringResources[resourceId] || resourceId



// WEBPACK FOOTER //
// ./src/config/string-resources.js